export default [
  {
    title: 'breadcrumb.parley',
    route: 'parley',
    icon: 'TvIcon',
    resource: 'parley-setup',
    action: 'read',
  }
];